export const UPI_COLLECT_ID = 'upiCollectId' as const;

export const SELECTED_UPI_OPTION = 'selectedUpiOption' as const;
